import React, { Component } from 'react';
import moment from 'moment';
import { bool, func, oneOf, string } from 'prop-types';
import { NativeDateType } from '@philips-internal/oswald-ui-constants';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { classNames, defaultClasses, isEnumValid, isFunction, isIOS, toMoment } from '@philips-internal/oswald-ui-utils';
import './native-date.css';
class NativeDate extends Component {
    constructor() {
        super(...arguments);
        this.onChange = (event) => {
            const { onChange } = this.props;
            const date = event.target.value;
            if (!date)
                return;
            const value = moment.utc(date, 'YYYY-MM-DD');
            if (isFunction(onChange)) {
                onChange(new ChangeEvent({ oldValue: toMoment(this.props.value), value }));
            }
        };
        this.inputRef = (input) => {
            input && (isIOS() ? input.click() : input.focus());
        };
    }
    getFormat(type) {
        const formats = {
            [NativeDateType.DATE]: 'YYYY-MM-DD',
            [NativeDateType.MONTH]: 'YYYY-MM',
        };
        return formats[type];
    }
    getFormattedValue() {
        const { type, value } = this.props;
        const mask = this.getFormat(type);
        return moment.utc(value).format(mask);
    }
    getEvents() {
        return isIOS()
            ? { onBlur: this.onChange }
            : { onChange: this.onChange };
    }
    getType() {
        const { type } = this.props;
        return isEnumValid(NativeDateType, type) ? type : NativeDateType.DATE;
    }
    render() {
        const events = this.getEvents();
        const type = this.getType();
        const className = classNames({
            'c-native-date': true,
            ...defaultClasses({
                enabled: Boolean(this.props.enabled),
            }),
        });
        return (React.createElement("input", { className: className, disabled: !this.props.enabled, max: "9999-12-31", min: "0001-01-01", ref: this.inputRef, type: type, value: this.getFormattedValue(), ...events }));
    }
}
NativeDate.propTypes = {
    enabled: bool,
    onChange: func,
    type: oneOf([NativeDateType.DATE, NativeDateType.MONTH]),
    value: string,
};
NativeDate.defaultProps = {
    enabled: true,
    type: NativeDateType.DATE,
};
export { NativeDate, };
//# sourceMappingURL=native-date.js.map